/**
 * Quem vê cada item do menu. Não há mais "organizador" como papel: qualquer conta organiza, e as
 * ferramentas aparecem quando a pessoa tem relação com algum evento.
 * - all: todo mundo
 * - admin: administrador
 * - owner: quem criou algum evento
 * - team: quem foi delegado a algum evento ("Equipe dos eventos")
 * - finance: quem é Financeiro de algum evento
 */
export type MenuAudience = 'all' | 'admin' | 'owner' | 'team' | 'finance';

export type MenuContext = {
  isAdmin: boolean;
  ownsEvents: boolean;
  isTeam: boolean;
  isFinance: boolean;
};

export const isMenuVisible = (visibleTo: MenuAudience[], context: MenuContext): boolean =>
  visibleTo.some((audience) => {
    switch (audience) {
      case 'all':
        return true;
      case 'admin':
        return context.isAdmin;
      case 'owner':
        return context.ownsEvents;
      case 'team':
        return context.isTeam;
      case 'finance':
        return context.isFinance;
      default:
        return false;
    }
  });

/** Tela inicial do painel: a tabela de eventos para quem trabalha com eventos; a arena para os demais. */
export const dashboardStartPath = (
  context: Pick<MenuContext, 'isAdmin' | 'ownsEvents' | 'isTeam'>
): string =>
  context.isAdmin || context.ownsEvents || context.isTeam
    ? '/dashboard/evento/tabela'
    : '/dashboard/eventos';
